import React from "react";

import { Icon } from "@iconify/react/dist/iconify.js";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";

export type BackgroundContentProps = {
  title: string | React.ReactNode;
  id: string;
  children: React.ReactNode[];
};
const BackgroundTasks: React.FC<BackgroundContentProps> = ({ title, children, id }) => {
  const [expanded, setExpanded] = React.useState<boolean>(true);
  return (
    <Accordion
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
      sx={{
        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
        "&:hover": {
          boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
        },
        transition: "box-shadow 0.2s ease-in-out",
        borderRadius: "8px",
        "&:before": {
          display: "none", // Elimina la línea divisoria por defecto del Accordion
        },
      }}
    >
      <AccordionSummary
        expandIcon={<Icon icon="mdi:chevron-down" />}
        aria-controls={`panel2-content-${id}`}
        id={`panel2-header-${id}`}
      >
        <Typography component="span" sx={{ width: "100%" }}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {children.map((item, index) => (
          <div key={`${id}-${index}`}>{item}</div>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

export default BackgroundTasks;
